declare const APP_VERSION: string
declare const GIT_LATEST_COMMIT_SHA: string

export default defineNuxtPlugin(() => {
  const { app: { environment } } = useRuntimeConfig()

  if (environment === 'production') {
    // eslint-disable-next-line no-console
    console.info(`Current version: ${APP_VERSION}`)
  }
  else {
    // eslint-disable-next-line no-console
    console.info(`Latest git commit SHA: ${GIT_LATEST_COMMIT_SHA}`)
  }
})
